import { getAxiosConfig } from "@/services/axiosConfig";
import {
  IBestSellerDataGeneric,
  IBestSellers,
  IBrandsGeneric,
} from "global-types/global.types";
import { useQuery } from "react-query";

export default function useNewProducts(slug: string[]) {
  const { data: newProducts, isLoading: isLoadingNewProducts } = useQuery(
    ["NEW_PRODUCTS", slug],
    async () => {
      if (!slug) return null;

      const res = await getAxiosConfig().get<
        IBestSellers<IBestSellerDataGeneric<IBrandsGeneric>[]>
      >(`/category/product?category_id=${slug}&take=3&new=1`);

      return res.data;
    }
  );

  return {
    newProducts,
    isLoadingNewProducts,
  };
}
